export function storageMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      storageId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateStorageId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyStorages(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateStorageId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function storageMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, storageId: json.result.objectId},
  };
}